import React from "react";
import { Button, Dropdown, Space } from "antd";
import { MoreVertical } from "lucide-react";

const TableActions = ({ actions, isMobile, inline }) => {
  if (!actions || actions.length === 0) {
    return null;
  }

  const visibleActions = actions.filter(Boolean);

  if (isMobile && !inline) {
    const menuItems = visibleActions.map((action, index) => ({
      key: action.key || String(index),
      label: action.label || "Ação",
      icon: action.icon,
      onClick: action.onClick,
    }));

    return (
      <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
        <Button
          type="text"
          icon={<MoreVertical size={20} />}
          aria-label="Ações"
          style={{ minWidth: 44, minHeight: 44 }}
        />
      </Dropdown>
    );
  }

  return (
    <Space size="middle" wrap>
      {visibleActions.map((action, index) => (
        <span key={action.key || index}>{action.icon || action.node}</span>
      ))}
    </Space>
  );
};

export default TableActions;
